<template>
  <transition name="no-mode-fade">
    <div
      id="home"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="home-tab"
    >
      <div class="row mb-3 mt-3">
        <div class="col-md-3">
          <b-button-group>
            <b-button variant="outline-danger">
              <input
                v-model="selectAll"
                type="checkbox"
                @change="selectItemAll(selectAll)"
              />
            </b-button>
            <b-button
              variant="outline-danger"
              type="button"
              :disabled="recordIds.length == 0"
              @click="multiDelete" v-if="$role=='super_admin'"
            >
              <i class="fa fa-trash" />
              {{ $t("site.bulk_delete") }}
            </b-button>
          </b-button-group>
          <!-- end of form -->
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input
              v-model="search"
              type="text"
              autofocus
              class="form-control"
              :placeholder="$t(`site.search`)"
              @input="(val) => searchChange(val)"
            />
          </div>
        </div>
        <div class="col-3">
          <div class="float-md-right pt-1">
            <span class="text-muted text-small mr-1 mb-2"
              >{{ from }}:{{ to }}
            </span>
            <b-dropdown
              id="ddown2"
              right
              :text="`${perPage}`"
              variant="outline-warning"
              size="xs"
            >
              <b-dropdown-item
                v-for="(size, index) in [5, 10, 20, 50, 100]"
                :key="index"
                @click="changePageSize(size)"
                >{{ size }}</b-dropdown-item
              >
            </b-dropdown>
            <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
          </div>
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->

      <!-- end of row -->
      <hr />

      <div class="row">
        <div class="col-md-12">
          <!-- draggable -->
          <b-list-group flush>
            <b-list-group-item disabled>
              <b-row>
                <b-col lg="1"> #</b-col>
                <b-col lg="1"> {{ $t("edu_contents.code") }}</b-col>
                <b-col lg="6" v-if="eduProgram.flixable == 0">{{
                  $t("edu_contents.name")
                }}</b-col>

                <b-col lg="3" v-if="eduProgram.flixable == 1"
                  >{{ $t("edu_contents.name") }}
                </b-col>
                <b-col lg="3" v-if="eduProgram.flixable == 1">{{
                  $t("edu_contents.lecture_time")
                }}</b-col>
                <b-col lg="2">
                  {{ $t("edu_contents.type") }}
                </b-col>
                <b-col lg="2">
                  {{ $t("site.action") }}
                </b-col>
              </b-row></b-list-group-item
            >
          </b-list-group>
          <hr />
          <draggable
            v-model="data"
            tag="ul"
            class="list-group list-group-flush cursor-move"
            @end="onEnd"
            :options="{ disabled: disableDraggable }"
          >
            <b-list-group-item
              v-for="(item, index) in data"
              :key="index"
              tag="li"
            >
              <b-row :class="{ ' bg-info text-white': item.type == 'exam' }">
                <b-col lg="1"
                  ><label
                    class="kt-checkbox kt-checkbox--single kt-checkbox--solid"
                  >
                    <input
                      v-model="recordIds"
                      type="checkbox"
                      :value="item.id"
                      @change="selectItem(item)"
                    />
                    <span /> </label
                ></b-col>
                <b-col lg="1">
                  {{ index + 1 + perPage * (currentPage - 1) }}</b-col
                >
                <b-col lg="6" v-if="eduProgram.flixable == 0"
                  >{{ item.name }}
                </b-col>
                <b-col lg="3" v-if="eduProgram.flixable == 1"
                  >{{ item.name }}
                </b-col>
                <b-col lg="3" v-if="eduProgram.flixable == 1"
                  >{{ item.rooms[0].pivot.start_in }}
                </b-col>
                <b-col lg="2">
                  <h6>
                    <span class="badge badge-success">{{
                      $t("edu_contents." + item.type)
                    }}</span>
                  </h6>
                </b-col>
                <b-col lg="2">
                  <button
                    class="btn btn-icon btn-warning btn-sm"
                    @click="editItem(item)"
                  >
                    <i class="fa fa-edit" />
                  </button>
                  <button
                    type="submit"
                    class="btn btn-icon btn-danger btn-sm delete"
                    @click="deleteItem(item)"
                  >
                    <i class="fa fa-trash" />
                  </button>
                </b-col>
              </b-row>
            </b-list-group-item>
          </draggable>

          <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />

          <hr />

          <b-pagination
            v-model="currentPage"
            align="right"
            class="dataTables_paginate paging_simple_numbers pagination-warning"
            :total-rows="totalRows"
            :per-page="perPage"
            @input="onChangePage()"
          >
            <template v-slot:next-text>
              <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
              <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
              <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
              <i class="fas fa-step-backward" />
            </template>
          </b-pagination>

          <!-- end of table -->
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->
    </div>
  </transition>
</template>

<script>
import Controller from "@/Controllers/EduContentController";

import config from "../../../../config/config";
import EduProgramsController from "@/Controllers/EduProgramsController";
import draggable from "vuedraggable";
var controller;
export default {
  components: {
    draggable,
  },
  props: ["items", "editItem"],
  data() {
    return {
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      data: [],
      eduProgram: {},
      disableDraggable: false,
    };
  },
  async created() {
    this.load = true;
    let res = await new EduProgramsController().AssignOfficialExams(
      this.$route.params.eduProgramId
    );
    controller = new Controller(res.courses[0].id);
    this.eduProgram = res.eduProgram;
    if (this.eduProgram.flixable == 1) {
      this.disableDraggable = true;
    }

    // data[0].rooms[0].pivot.start_in;
    this.dataProvider({});
  },

  methods: {
    async onEnd(evt) {
      let index = (this.currentPage - 1) * this.perPage;
      await controller.Order({
        oldOrder: evt.oldIndex + index,
        newOrder: evt.newIndex + index,
      });
      this.dataProvider({});
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.dataProvider({});
    },

    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      if (!controller) {
        return [];
      }
      const data = await controller.GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.data = data.data;
      this.to = data.to;
      this.total = data.total;

      this.load = false;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      apiParams.sort = "order|asc";
      if (this.currentPage >= 1) {
        apiParams.page = this.currentPage;
      }

      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.with = ["rooms"];
      return apiParams;
    },

    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
    },

    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
      }
      if (this.search.length < 2) return;

      this.page = 1;
      this.dataProvider(this.params);
    },
    selectItem(val, select) {
      if (select) {
        this.recordIds.push(val.id);
      } else {
        const index = this.recordIds.indexOf(val.id);
        if (index !== -1) {
          this.recordIds.splice(index, 1);
        }
      }
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      controller.Delete(data.id, [], this.$refs.table);
    },
    multiDelete() {
      controller.Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>

<style></style>
